import SuggestionForm from "../SuggestionForm/SuggestionForm.jsx";
import { useState } from "react";

function SuggestionWidget({ config }) {
  const [isPopUpOpen, setIsPopUpOpen] = useState(false);
  const [showFamilyRoleRequired, setShowFamilyRoleRequired] = useState(false);
  const loginPopUp = document.getElementById("login-popup-wrapper");

  const has_role_permission = config.has_role_suggestions_permission.toLowerCase() === "true"

  const handleOpenPopUp = () => {
    if (!has_role_permission) {//Si hay declarado un rol requerido chequea la condicion
      setShowFamilyRoleRequired(true);
    } else {
      setIsPopUpOpen(true);
    }
  };

  const handleClosePopUp = () => {
    setIsPopUpOpen(false);
  };
  const showLoginPopUp = () => {
    if (loginPopUp) {
      loginPopUp.classList.add("popup-visible");
    }
  };

  return (
    <>
      <div className="SuggestionWidget">
        <i className="icon-blog-1"></i>
        <h3 className="SuggestionWidget_title">
          {config.translations.suggestionTitle}
        </h3>
        <button
          onClick={
            config.profile === ""
              ? () => showLoginPopUp()
              : () => handleOpenPopUp()
          }
          className="SuggestionWidget_button"
        >
          <i className="icon-proposal"></i>
          {config.translations.suggestionTextBtn}
        </button>
        <p className="SuggestionWidget_roleWarning">
          {showFamilyRoleRequired && config.translations.suggestionErrorRole}
        </p>
      </div>
      {isPopUpOpen && (
        <SuggestionForm handleClosePopUp={handleClosePopUp} config={config} />
      )}
    </>
  );
}

export default SuggestionWidget;
